/* NO-REPEAT GUARD (Bruce, 16 Oct: "I should never see the same look shown twice").
   One pass over the page in reading order. A look (any frame of marcel-look-lNNN) or a product photo may appear once.
   Editorial images (hero, push slots) come first in the page and always win. A product card that would repeat a picture
   swaps to its unused second picture, otherwise the card is removed from that rail or grid. Hover pictures that repeat are dropped. */
(function () {
  function key(img) {
    var u = (img.currentSrc || img.src || '').split('?')[0];
    var f = u.split('/').pop() || '';
    if (!f || f.indexOf('data:') === 0) return '';
    var m = f.match(/marcel-look-(l\d+)/i);
    if (m) return 'look:' + m[1].toLowerCase();
    return 'file:' + f.replace(/_(\d+x\d*|x\d+|\d+x)(?=\.)/, '').toLowerCase();
  }
  function run() {
    var seen = Object.create(null), dropped = 0;
    var root = document.querySelector('main') || document.body;
    // a PRODUCT shows once per page: the shop-the-look cards win, a later rail or grid card for the same product is dropped
    var shown = Object.create(null);
    root.querySelectorAll('.mps__card[data-handle], .mx-card__a[data-mx-item]').forEach(function (el) {
      var h = el.getAttribute('data-handle') || el.getAttribute('data-mx-item'); if (!h) return;
      var li = el.closest('li'); if (!li || li.closest('[data-ma-repeat]') || li.style.display === 'none') return;
      if (shown[h] && el.classList.contains('mx-card__a')) { li.style.display = 'none'; li.setAttribute('data-ma-repeat', 'product:' + h); dropped++; }
      shown[h] = 1;
    });
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.closest('[hidden], [data-ma-repeat], .mx-sw, header, footer')) continue;
      var k = key(img); if (!k) continue;
      var card = img.closest('.mx-card');
      if (!card) {
        // editorial picture: a look already shown (any frame) is hidden, on every page
        if (seen[k] && k.indexOf('look:') === 0) { var box = img.closest('figure, picture, .mps__media, .mx-hero__panel') || img; box.style.display = 'none'; box.setAttribute('data-ma-repeat', k); dropped++; }
        seen[k] = 1; continue;
      }
      if (img.classList.contains('mx-card__i2')) {
        if (seen[k]) { img.remove(); var md = card.querySelector('.mx-card__media--swap'); if (md) md.classList.remove('mx-card__media--swap'); }
        else seen[k] = 1;
        continue;
      }
      if (!seen[k]) { seen[k] = 1; continue; }
      var alt = card.querySelector('.mx-card__i2'), ak = alt && key(alt);
      if (alt && ak && !seen[ak]) {
        img.srcset = alt.srcset; img.src = alt.src; alt.remove();
        var m2 = card.querySelector('.mx-card__media--swap'); if (m2) m2.classList.remove('mx-card__media--swap');
        seen[ak] = 1;
      } else {
        var li = card.closest('li') || card; li.style.display = 'none'; li.setAttribute('data-ma-repeat', k); dropped++;
      }
    }
    // a rail never shows half-empty (Bruce, 18 Oct: "needs stronger formatting"): under 4 visible cards, the whole section goes
    root.querySelectorAll('.mx-rail').forEach(function (rail) {
      var n = 0;
      rail.querySelectorAll('li').forEach(function (li) { if (li.querySelector('.mx-card') && li.style.display !== 'none') n++; });
      if (n >= 4) return;
      rail.style.display = 'none'; rail.setAttribute('data-ma-thin', String(n));
      // the wrapper goes too only when the rail was all it held (never a cart or page section with other content)
      var sec = rail.closest('.shopify-section');
      if (sec && sec.offsetHeight < 40) sec.style.display = 'none';
    });
    document.documentElement.setAttribute('data-ma-norepeat', String(dropped));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();
